<template>
  <div v-if="carTypes !== ''" class="as-app-car-types-wrapper">
    <a :href="$store.state.marketPath" class="as-app-car-types-col" @click="openTypeResults('Compact')">
      <span class="as-app-car-type-count">{{ carTypes.Kleinwagen.metadata.totalCount }}</span>
      <span class="as-app-car-type-name">Kleinwagen</span>
    </a>
    <a :href="$store.state.marketPath" class="as-app-car-types-col" @click="openTypeResults('Sedan')">
      <span class="as-app-car-type-count">{{ carTypes.Limousinen.metadata.totalCount }}</span>
      <span class="as-app-car-type-name">Limousinen</span>
    </a>
    <a :href="$store.state.marketPath" class="as-app-car-types-col" @click="openTypeResults('StationWagon')">
      <span class="as-app-car-type-count">{{ carTypes.Kombis.metadata.totalCount }}</span>
      <span class="as-app-car-type-name">Kombis</span>
    </a>
    <a :href="$store.state.marketPath" class="as-app-car-types-col" @click="openTypeResults('OffRoad')">
      <span class="as-app-car-type-count">{{ carTypes.SUV.metadata.totalCount }}</span>
      <span class="as-app-car-type-name">SUVs</span>
    </a>
    <a :href="$store.state.marketPath" class="as-app-car-types-col" @click="openTypeResults('Convertible')">
      <span class="as-app-car-type-count">{{ carTypes.Cabrio.metadata.totalCount }}</span>
      <span class="as-app-car-type-name">Cabrios</span>
    </a>
  </div>
</template>

<script>
  import Vue from 'vue'
  export default {
    name: 'CarTypes',
    props: {
      msg: String
    },
    data () {
      return {
        carTypes: '',
      }
    },
    methods:{
      openTypeResults: function (type) {
        // this.$store.commit('resetSearchParams') //Reset SearchParams
        this.$store.commit('updateSearchParams', {bodyTypeEnumProxy: type}) //Build object that will be merged into state.searchParams
      }
    },
    computed: {

    },
    apollo :{
      carTypes: {
        query: require('../graphql/CarTypes.gql'),
        errorPolicy: 'all',
        error(error) {
          // console.log({error})
          if(parseInt(error.networkError.statusCode) === 429){
            Vue.logApiLimitReached();
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../styles/style.scss";
  @import "../styles/partials/_car-types";
</style>